import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  private readonly DURATION = 3000;

  constructor(private snackBar: MatSnackBar) { }

  open(message: string) {
    this.snackBar.open(message, null, { 
      duration: this.DURATION, 
      panelClass: ['custom-snackbar'] //declared in global styles.scss
    })
  }
}
